import {
  createSlice,
  type PayloadAction,
  createAction,
} from '@reduxjs/toolkit';

import { GAME_ID_FROM_URL } from '@ezugi/constants';
import { GenericPayloadType, TableChip } from '@ezugi/types';

type GameSetPayload = GenericPayloadType;

export type GameState = {
  selectedChip?: TableChip;
  started: boolean;
  limitId?: number;
  gameId: number | string;
  tableId?: string;
  name: string;
  serverName?: string;
};

export const initialState: GameState = {
  started: false,
  gameId: GAME_ID_FROM_URL,
  name: 'unknown',
};

export const selectChipRequestAction = createAction<TableChip>('selectChip/request');
export const selectChipSuccessAction = createAction('selectChip/success');
export const selectChipFailureAction = createAction('selectChip/failure');
export const selectChipSetAction = createAction<TableChip>('selectChip/set');

export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    request() {},
    success() {},
    failure() {},
    set(state, { payload }: PayloadAction<GameSetPayload>) {
      return {
        ...state,
        ...payload,
      };
    },
    start(state) {
      return {
        ...state,
        started: true,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      selectChipSetAction,
      (state, { payload }: PayloadAction<TableChip>) => ({
        ...state,
        selectedChip: payload,
      }),
    );
  },
});

export const gameActions = gameSlice.actions;
export default gameSlice.reducer;
